module.exports = __webpack_public_path__ + "static/media/DocsStrat.00c40e73.pdf";